import { render, staticRenderFns } from "./list-item-revition.vue?vue&type=template&id=06e90027"
import script from "./list-item-revition.vue?vue&type=script&lang=js"
export * from "./list-item-revition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports